export default __webpack_public_path__ + "static/Entenda0072-1b5e252bf16f8295d8425e4d80ec4eaa.jpg";